import Swiper from 'swiper';
import {
	A11y,
}             from 'swiper/modules';

/**
 * @function steps
 * @description Initialize Swiper slider with accessibility features.
 * @param {HTMLElement} el - Container element with class `swiper` inside.
 * @param {MediaQueryList} breakpoint - Media query to toggle slider on/off.
 * @returns {Swiper} - Instance of Swiper.
 */
export default function steps(el, breakpoint = window.matchMedia('(min-width : 681px)')) {
	if (!el) {
		return false;
	}
	const slider     = el.querySelector('.swiper');
	let swiper;
	const settings   = {
		modules       : [A11y],
		loop          : false,
		slidesPerView : 'auto',
		spaceBetween  : 0,
		a11y          : {
			prevSlideMessage        : 'Предыдущий слайд',
			nextSlideMessage        : 'Следующий слайд',
			paginationBulletMessage : 'Перейти к {{index}}',
			firstSlideMessage       : 'Первый слайд',
		},
	};
	
	const enableSlider = () => {
		swiper = new Swiper(slider, settings);
	};
	
	const breakpointChecker = () => {
		if (breakpoint.matches === true) {
			if (swiper !== undefined) {
				swiper.destroy(true, true);
			}
		} if (breakpoint.matches === false) {
			return enableSlider();
		}
		return null;
	};
	try {
		breakpoint.addEventListener('change', breakpointChecker);
	} catch (e) {
		// Safari <14
		breakpoint.addListener(breakpointChecker);
	}
	
	breakpointChecker();
	
	return swiper;
}
